import ProfileListReducer from './ProfileListReducer';

export default from './ProfileListContainer';

export const ProfileListReducers = {
  ProfileListReducer,
};
